import React from "react";
import ServicePage from "../components/ServicePage";
import bannerimg from "../../media/bannerimg.jpg";
import heroImg from "../../media/consultingmain.jpg"; // You can replace this with a dedicated consulting image later
import sideImg1 from "../../media/consultingmain1.jpg";
import sideImg2 from "../../media/accountingmain2.png";
import ctaBg from "../../media/servicesidecta.png";
import usePageTitle from "../components/usePageTitle";

const Consulting = () => {
  usePageTitle("Counsulting");
  return (
    <ServicePage
      title="Consulting"
      breadcrumb="Consulting"
      bgImage={bannerimg}
      heroImg={heroImg}
      sectionTitle="Expert Consulting for Sustainable Growth"
      description="Our consulting services are built on years of real-world experience in both the public and private sectors. Whether you’re navigating rapid growth, financial restructuring, or internal control challenges, we bring expert guidance and proven solutions to the table. At Aspen SR, we work closely with leadership teams to optimize financial operations, implement accounting systems, improve budget performance, and ensure your organization is future-ready. We don't just offer advice—we help you build sustainable systems for long-term success."
      overviewItems={[
        "Clear vision and direction for your business or consulting.",
        "Enhanced ability to anticipate and respond to market changes.",
        "Data-driven decision-making for strategic planning execution.",
        "Structured approach to achieving your business goals.",
      ]}
      featureItems={[
        {
          icon: "bi-lightbulb",
          title: "Insightful Guidance",
          text: "Practical and expert-backed consulting to support growth.",
        },
        {
          icon: "bi-gear",
          title: "System Optimization",
          text: "We help you optimize your financial processes and tools.",
        },
        {
          icon: "bi-people",
          title: "Leadership Support",
          text: "Partnering directly with your management for success.",
        },
      ]}
      faqList={[
        {
          id: 1,
          question: "What consulting services do you offer?",
          answer:
            "We offer strategic financial consulting, internal control reviews, system implementation, and more tailored to nonprofits, government, and businesses.",
        },
        {
          id: 2,
          question: "Who are your typical consulting clients?",
          answer:
            "Our clients include nonprofit organizations, government-funded initiatives, startups, and growing businesses seeking expert financial systems.",
        },
        {
          id: 3,
          question: "Can you help during financial restructuring?",
          answer:
            "Absolutely. We specialize in guiding organizations through restructuring, helping you stay compliant while strengthening internal processes.",
        },
        {
          id: 4,
          question: "Do you provide support after implementation?",
          answer:
            "Yes, we offer ongoing support, system tuning, and advisory services to ensure sustainable success beyond the initial implementation.",
        },
      ]}
      sideImage1={sideImg1}
      sideImage2={sideImg2}
      ctaBg={ctaBg}
      phoneNumber="(+1) 720-412-7990"
    />
  );
};

export default Consulting;
